import { computed } from "vue";

export function useDynamicTopPositioning(props) {
    const dynamicSoldToY = (baseTop) => {
        const lineHeight = 14;
        const maxWidth = 200;
        const charWidth = 8;
        const text = props.serviceInvoiceData?.payee?.sold_to || "";

        if (!text) return baseTop;

        const charsPerLine = Math.floor(maxWidth / charWidth) || 1;
        const rows = Math.ceil(text.length / charsPerLine);
        return baseTop - (rows - 1) * lineHeight;
    };

    return { dynamicSoldToY };
}